module.exports = __webpack_public_path__ + "media/images/icon-notices-menu-9575787401d34d07c4fdd96b8700f6dc.svg";